export default __webpack_public_path__ + "static/media/arrow_down_right.afa987c6.svg";